module.exports = "/src/views/player/help/images/azs.jpg";